export const GET_PERIODS_LIST = 'PERIODS/GET_PERIODS_LIST'
export const GET_PERIODS_LIST_FAILED = 'PERIODS/GET_PERIODS_LIST_FAILED'
export const GET_PERIODS_LIST_SUCCESS = 'PERIODS/GET_PERIODS_LIST_SUCCESS'

export const CREATE_PERIODS_BATCH = 'PERIODS/CREATE_PERIODS_BATCH'
export const CREATE_PERIODS_BATCH_FAILED = 'PERIODS/CREATE_PERIODS_BATCH_FAILED'
export const CREATE_PERIODS_BATCH_SUCCESS = 'PERIODS/CREATE_PERIODS_BATCH_SUCCESS'

export const CLEAR_PERIODS_LIST = 'PERIODS/CLEAR_PERIODS_LIST'
